export class CustomParamsUploadedReferralStatusModel {
  LastName: string;
  FileName: string;
  StatusId: number;
}
